import { ICellRendererParams } from 'ag-grid-community';

import { AddVendorAssociation } from 'companySettings/components/ApprovedVendors/AddVendorAssociation';
import { TextEllipsis } from 'core/elements';
import { Level } from 'theme/enums';

export const ManufacturerCell = ({ api, data }: ICellRendererParams) => {
  const nodes = api.getRenderedNodes();
  const firstManufacturerNode = nodes.find(
    (node) => node.data?.manufacturerId === data?.manufacturerId
  );
  const shouldSkipValueToAllowColSpan = firstManufacturerNode?.data?.id !== data?.id;

  if (shouldSkipValueToAllowColSpan) {
    return null;
  }

  const onSubmitSuccess = () => {
    api.refreshServerSide({ purge: true });
  };

  return (
    <>
      <TextEllipsis level={Level.BODY_MD} fontWeight={600} content={data.manufacturerName} />
      <AddVendorAssociation
        manufacturerId={data.manufacturerId}
        manufacturerName={data.manufacturerName}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
